import { render, staticRenderFns } from "./StoneTypeEdit.vue?vue&type=template&id=0bca3aa1&scoped=true&"
import script from "./StoneTypeEdit.vue?vue&type=script&lang=js&"
export * from "./StoneTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca3aa1",
  null
  
)

export default component.exports